GoogleApiUtility = {
    InitMapWithMarker(lat, lng, elementId = 'map', zoom = 15) {
        // Default coordinates (e.g., New York City)
        const coordinates = {
            lat: parseFloat(lat),
            lng: parseFloat(lng)
        };

        // Create the map centered on the default coordinates
        let map = new google.maps.Map(document.getElementById(elementId), {
            zoom: zoom,
            center: coordinates,
        });

        // Create a marker at the default position
        let marker = new google.maps.Marker({
            position: coordinates,
            map: map,
        });
    },
    LoadGoogleMapsScript(APIKEY) {
        return new Promise((resolve, reject) => {
            if (window.google && window.google.maps) {
                return resolve(); // Google Maps already loaded
            }
            // Define a global callback function
            window.initGoogleMaps = () => {
                resolve(); // Resolve the promise when the script is fully loaded
            };
            const script = document.createElement('script');
            script.src = 'https://maps.googleapis.com/maps/api/js?key=' + APIKEY + '&loading=async&libraries=places,marker&callback=initGoogleMaps&language=bg'; // Remove callback from URL

            // Add the `loading="async"` and `defer` attributes for optimal performance
            script.async = true;  // Ensure the script is loaded asynchronously
            script.defer = true;  // Ensure it runs after the document is fully parsed

            script.onerror = () => reject('Error loading Google Maps script');

            document.head.appendChild(script);
        });
    }
};